var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('on-board-top-navbar'),_c('step-signal'),_c('on-board-bottom-navbar'),_c('div',{staticClass:"on-board-content"},[_c('timon'),_c('router-view'),_c('OnboardSideBox')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }